<template>
  <div class="country">
    {{ value }}
  </div>
</template>

<script>
//import store from '@/store/';
import { LOAD_COUNTRIES } from '@/store/consts';

export default {
  name: "Country",
  namespaced: true,
  data() {
    return {
      visible: false,
    };
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    iso: {
      type: String,
      default: "us",
    },
  },
  computed: {
    value: function () {
        return this.$store.getters.countryNameByISO(this.iso)
    }
  },
  mounted() {
      this.$store.dispatch(LOAD_COUNTRIES)
  }
};
</script>

<style scoped>
</style>